import api from "./api";

// 新增编辑EC Banner广告
export const updateECBannerAD = params => {
  return api("post", `/v1/management/ec-banner-advertising/edit`, params);
};

// EC Banner广告列表
export const postECBannerAD = params => {
  return api("post", `/v1/management/ec-banner-advertising/list`, params);
};
